var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { config, useState, getStorage, setStorage, removeStorage, concatURI } from "..";
export const AccountTokenKey = config.uaId + 'ACCOUNT_TOKEN';
/**
 * 单点登录
 * @description 根据`auth_code`获取登录`token`
 * @param {string} auth_code
 */
export function GetAccountToken(auth_code) {
    var _a;
    return (_a = config.proxyRequest) === null || _a === void 0 ? void 0 : _a.get(`/token`, { params: { auth_code } });
}
/**
 * 获取账号信息
 */
const AccountInfoKey = Symbol();
export function GetAccountInfo(refresh = false) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield useState(AccountInfoKey, () => {
            var _a;
            return (_a = config.proxyRequest) === null || _a === void 0 ? void 0 : _a.get(`/info`);
        }, refresh);
    });
}
/**
 * 获取账号token
 * @export
 * @param {string} [code]
 */
export function getAccountToken(code) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        let token = getStoragedAccountToken();
        if (!token && code) {
            token = (_a = (yield GetAccountToken(code))) === null || _a === void 0 ? void 0 : _a.token;
            setStorage(AccountTokenKey, token);
        }
        return token;
    });
}
export function getStoragedAccountToken() {
    return getStorage(AccountTokenKey);
}
/** 登录状态 */
export var SSO_Query_Status;
(function (SSO_Query_Status) {
    /** 登出 */
    SSO_Query_Status[SSO_Query_Status["Logout"] = 0] = "Logout";
})(SSO_Query_Status || (SSO_Query_Status = {}));
/**
 * 前往单点登录页
 * @param {SSO_Query['Status']} [status]
 * @param {string} [redirect=window.location.href]
 */
export function goLoginPage(status, redirect = window.location.href) {
    removeStorage(AccountTokenKey);
    window.location.replace(concatURI(config.SsoLink, { 'c_default_redirect': redirect, status }));
}
/**
 * 登出
 * @param {string} [redirect]
 */
export function logout(redirect) {
    goLoginPage(SSO_Query_Status.Logout, redirect);
}
